export const showConfirmDialog = (
  dialog,
  { title, message, acceptLabel, declineLabel, onAccept, onDecline },
) => {
  dialog.display(
    title,
    message,
    acceptLabel,
    declineLabel,
    (event) => {
      if (onAccept) {
        onAccept(event);
      }
      dialog.close();
    },
    (event) => {
      if (onDecline) {
        onDecline(event);
      }
      dialog.close();
    },
  );
};
